import axios from "axios";
import { getAnonymousID, getSessionID } from "redline-client-sdk";

import { useUserStore } from "@libs/acp/store/user/useUserStore";
import {
	clearACLocalData,
	handleRefreshToken,
	shouldRefreshToken,
} from "@libs/acp/utils/handleRefreshToken";

import { getIdentityBaseURL } from "./config";

const isCustomBuild = !!import.meta.env.VITE_CUSTOM_BUILD;
const isDev = import.meta.env.VITE_ENV === "dev";

const privateIdentityApiClient = axios.create({
	headers: {
		"Content-Type": "application/json",
		"x-anonymous-id": getAnonymousID(),
		"x-session-id": getSessionID(),
	},
	validateStatus: (status) => {
		return status >= 200 && status < 300;
	},
});

const privateRequestsWithRefreshToken = [
	"/v2/public/auth/refresh-token",
	"/v2/app/delete",
];

privateIdentityApiClient.interceptors.request.use(
	async (config) => {
		if (!config.baseURL) {
			config.baseURL = getIdentityBaseURL();
		}
		const shouldRefreshTokenBefore = await shouldRefreshToken();
		if (
			shouldRefreshTokenBefore &&
			config.url !== "/v2/public/auth/refresh-token"
		) {
			try {
				const response = await handleRefreshToken({
					refreshToken:
						useUserStore.getState().authenticatedUser.acp.auth.refresh_token ||
						"",
				});

				if (response?.access_token) {
					useUserStore.getState().updateACPAuthSession({
						access_token: response.access_token,
						refresh_token: response.refresh_token,
						isAuthenticated: true,
					});
				}
			} catch (err) {
				clearACLocalData();
				window.location.href = "/login";
				return Promise.reject(err);
			}
		}

		if (privateRequestsWithRefreshToken.includes(config.url || "")) {
			if (isCustomBuild) {
				config.baseURL = isDev
					? "https://dev-identity.consumidorpositivo.com.br"
					: "https://identity.consumidorpositivo.com.br";
			}

			config.headers["Refresh-Token"] =
				useUserStore.getState().authenticatedUser.acp.auth.refresh_token;
		}

		config.headers["Authorization"] =
			`Bearer ${useUserStore.getState().authenticatedUser.acp.auth.access_token}`;

		return config;
	},
	(error) => {
		return Promise.reject(error);
	},
);

export default privateIdentityApiClient;
